import React from 'react'
import Loadable from 'Components/LoadableToImported'
import { connect } from 'react-redux'
import { openLoginModal, openRegisterModal, openModal } from 'Modules/modals/actions'
import { loadPrintArchiveListings } from 'Modules/print/actions'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import { getUserIsOneOfAgentAdminSupport } from 'Modules/user/data/selectors'

import Spinner from 'Components/Spinner'

const loading = () => (
  <div style={{ width: '100%', height: '250px' }}>
    <Spinner />
  </div>
)

const ArchiveListings = Loadable({
  loader: () => import(/* webpackChunkName: "ArchiveListings" */ './ArchiveListings'),
  loading,
  chunkName: 'ArchiveListings',
})


export default connect(state => ({
  mobileBrowser: state.app.mobileBrowser,
  isMobile: state.app.isMobile,
  isMobileApp: state.app.isMobileApp,
  agent: state.userData.agent || state.userData.myAgent,
  userIsAuthentificated: state.userData.userIsAuthentificated,
  // ignore listing removal hidden fields if userIsOneOfAgentAdminSupport
  isUserAgentAdminSupport: getUserIsOneOfAgentAdminSupport(state),
  userEmailVerified: state.userData.user.emailVerified,
}), {
  openLoginModal,
  openRegisterModal,
  openModal,
  googleAnalyticsEvent,
})(ArchiveListings)


export const PrintListingArchiveListings = connect((state, props) => ({
  mobileBrowser: state.app.mobileBrowser,
  isMobile: state.app.isMobile,
  userIsAuthentificated: state.userData.userIsAuthentificated,
  archiveListingsData: props.archiveListingsData,
  isFetching: props.isFetching,
  total: props.total,
  isIE: state.app.isIE,
  hasArchiveListings: !!(props.archiveListingsData && props.archiveListingsData.total),
  userEmailVerified: state.userData.user.emailVerified,
}), {
  loadArchiveListings: loadPrintArchiveListings,
  openLoginModal,
  openRegisterModal,
  openModal,
  googleAnalyticsEvent,
})(ArchiveListings)
